import { render, staticRenderFns } from "./CurrentFiles.vue?vue&type=template&id=3505e00c&"
import script from "./CurrentFiles.vue?vue&type=script&lang=js&"
export * from "./CurrentFiles.vue?vue&type=script&lang=js&"
import style0 from "./CurrentFiles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports